// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-3e1060a1]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.activity_content_desk[data-v-3e1060a1]{padding:20px 0}.activity_content_mobile[data-v-3e1060a1]{padding:10px}.activity_content_mobile .describe[data-v-3e1060a1],.activity_content_mobile .title[data-v-3e1060a1]{padding:0 11px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
